import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SalesBreakoutState {
  aggregation: string;
  timeFrames: string;
  isChart: boolean;
  dollars: boolean;
  units: boolean;
  categoryType: string;
  noOfRecords: string;
  lineChart: boolean;
}

export const initialState: SalesBreakoutState = {
  aggregation: "month",
  timeFrames: "10",
  isChart: false,
  dollars: true,
  units: false,
  categoryType: "brand",
  noOfRecords: "5",
  lineChart: true,
};

export const salesBreakoutSlice = createSlice({
  name: "salesBreakout",
  initialState,
  reducers: {
    changeAggregationSalesBreakout: (
      state: SalesBreakoutState,
      action: PayloadAction<string>
    ) => {
      state.aggregation = action.payload;
    },
    changeDollarsSalesBreakout: (
      state: SalesBreakoutState,
      action: PayloadAction<boolean>
    ) => {
      state.dollars = action.payload;
    },
    changeUnitsSalesBreakout: (
      state: SalesBreakoutState,
      action: PayloadAction<boolean>
    ) => {
      state.units = action.payload;
    },
    changeSalesBreakoutTimeFrames: (
      state: SalesBreakoutState,
      action: PayloadAction<string>
    ) => {
      state.timeFrames = action.payload;
    },
    changeCategoryType: (
      state: SalesBreakoutState,
      action: PayloadAction<string>
    ) => {
      state.categoryType = action.payload;
    },
    changeRecords: (
      state: SalesBreakoutState,
      action: PayloadAction<string>
    ) => {
      state.noOfRecords = action.payload;
    },
    toggleChartSalesBreakout: (
      state: SalesBreakoutState,
      action: PayloadAction<boolean>
    ) => {
      state.isChart = action.payload;
    },
    toggleChartTypeSalesBreakout: (
      state: SalesBreakoutState,
      action: PayloadAction<boolean>
    ) => {
      state.lineChart = action.payload;
    },
  },
});

export const {
  changeAggregationSalesBreakout,
  changeSalesBreakoutTimeFrames,
  toggleChartSalesBreakout,
  changeCategoryType,
  changeRecords,
  changeDollarsSalesBreakout,
  changeUnitsSalesBreakout,
  toggleChartTypeSalesBreakout,
} = salesBreakoutSlice.actions;
